import { AbstractCollection } from '../../abstract/Collection';
import { AbstractDocument, Identifiable, Timestampable, Untrackable } from '../../abstract/Document';
import { type Place } from '../Places';
import { IWidget } from './Widgets.types';

@Identifiable
@Timestampable
@Untrackable
export class Widget extends AbstractDocument<IWidget> {
  readonly collections = {};
}

export class Widgets extends AbstractCollection<Widget, IWidget> {
  static path = 'widgets';

  constructor(document: Place) {
    super(document.collection(Widgets.path), Widget);
  }
}
